export const MotionGlobalConfig: {
    skipAnimations?: boolean
    instantAnimations?: boolean
    useManualTiming?: boolean
    WillChange?: any
    mix?: <T>(a: T, b: T) => (p: number) => T
} = {}
